/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {CurrencyValueModel} from './currency-value.model';
import {TimeAvailabilityModel} from './time-availability.model';
import {HandoverOfferDtoModel} from './handover-offer-dto.model';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';
import { DriverVoModel } from '@well/delivery-libs/driver-management/domain';

export class OfferDtoModel extends JSONable  {

  uuid: string | undefined = undefined;

  offerRequestUuid: string | undefined = undefined;

  price: CurrencyValueModel | undefined = undefined;

  details: string | undefined = undefined;

  driver: DriverVoModel | undefined = undefined;

  vehicle: VehicleVoModel | undefined = undefined;

  binding: boolean | undefined = undefined;

  handoverOfferDtos: HandoverOfferDtoModel[] | undefined = undefined;

  transitDays: string | undefined = undefined;

  contactPhone: string | undefined = undefined;

  timeAvailability: TimeAvailabilityModel | undefined = undefined;

  canNegotiate: boolean | undefined = undefined;

  basedOnOfferUuid: string | undefined = undefined;

  basedOnMasterRoutingSolutionUuid: string | undefined = undefined;

  amendment: string | undefined = undefined;

  paymentTimeLimit: string | undefined = undefined;

  series: string | undefined = undefined;
}
